import * as actionTypes from './actionTypes'

export const updateTableCache = (tableKeyArg, tableValueArg) => {
    return {
        type: actionTypes.UPDATE_TABLECACHE,
        tableKey: tableKeyArg,
        tableValue: tableValueArg,
    };
}